export const SESSION_REPLAY_RETENTION = {
    DEFAULT: 30,
    MIN: 1,
    MAX: 744,
};
//# sourceMappingURL=session-replay.limits.js.map